import { useEffect, useState } from 'react';
import { useNomenclatureItems } from '@/features/common/useNomenclatureItems';
import { EVENT_THEMES } from '@/features/common/eventThemes';
import { publicEventsApi } from '@/features/publicsite/events/api/publicEventsApi';
import type { TerritorialUnit } from '@/features/common/types/TerritorialUnit';
import type { EventFilterOptions } from '@/features/publicsite/types/events/EventFilterOptions';
import type { OrganizerOption } from '@/features/publicsite/types/events/OrganizerOption';

/** The choices the calendar's region, theme and organiser lists offer. */
export function useEventFilterOptions(): EventFilterOptions {
  const [regions, setRegions] = useState<TerritorialUnit[]>([]);
  const themeOptions = useNomenclatureItems(EVENT_THEMES);
  const [organizerOptions, setOrganizerOptions] = useState<OrganizerOption[]>([]);

  // Territorial units and organisers, each fetched once regardless of the active filters — so
  // narrowing by region does not also shrink which organisers the "Organizator" select offers.
  //
  // The organisers come from their own endpoint rather than being read off the calendar's rows.
  // That worked only while the calendar answered with every event at once: one page of twelve
  // carries the organisers of twelve events, so the list would have offered whichever organisers
  // happened to be on the page being read and changed under the reader as they paged.
  useEffect(() => {
    publicEventsApi
      .territorialUnits()
      .then(setRegions)
      .catch(() => undefined);
    publicEventsApi
      .organizers()
      .then(setOrganizerOptions)
      .catch(() => undefined);
  }, []);

  return { regions, themeOptions, organizerOptions };
}
